import React from "react";
import LegalPage from "./LegalPage";

export default function DPA() {
    return (
        <LegalPage
            testid="page-dpa"
            title="Data Processing Addendum"
            subtitle="Scaffold DPA for enterprise procurement. Sign the countersigned PDF for binding effect."
            lastUpdated="21 April 2026"
        >
            <p>
                This Data Processing Addendum ("DPA") forms part of the agreement
                between the customer ("Controller") and AudRI ("Processor") for the
                provision of the AudRI platform. This page is a scaffold intended to
                unblock procurement and security review; the counter-signed PDF
                supersedes this page.
            </p>

            <h2>1. Roles and subject matter</h2>
            <p>
                Controller determines the purposes and means of processing. Processor
                processes personal data on behalf of Controller to provide the
                AudRI service as described in the underlying agreement.
            </p>

            <h2>2. Categories of data and data subjects</h2>
            <ul>
                <li>
                    <strong>Data subjects:</strong> Controller's authorised users
                    (QA auditors, QA managers, system owners), plus any personal data
                    incidentally contained in uploaded validation documents.
                </li>
                <li>
                    <strong>Categories of personal data:</strong> name, business
                    email, organisation, role, audit-trail metadata, and any
                    personal data contained in customer content.
                </li>
            </ul>

            <h2>3. Sub-processors</h2>
            <p>
                Processor may engage sub-processors subject to flow-down obligations
                no less protective than this DPA. Processor maintains an up-to-date
                list at{" "}
                <a href="mailto:privacy@audri.app">privacy@audri.app</a>. Controller
                may object to new sub-processors within 15 days.
            </p>

            <h2>4. Security measures</h2>
            <ul>
                <li>Encryption in transit (TLS 1.2+) and at rest (AES-256).</li>
                <li>
                    Role-based access, least-privilege production access,
                    time-limited admin credentials.
                </li>
                <li>
                    Immutable audit trail of data-plane mutations, retained for the
                    statutory retention period.
                </li>
                <li>
                    SHA-256 integrity hashing for every uploaded document; original
                    files retained bit-for-bit in object storage.
                </li>
                <li>
                    {"{{TODO: certifications — SOC 2 Type II (in progress), ISO 27001 (target).}}"}
                </li>
            </ul>

            <h2>5. International transfers</h2>
            <p>
                Where Processor transfers personal data outside the EEA, UK or
                Switzerland, the Standard Contractual Clauses ("SCCs") and UK IDTA
                are incorporated by reference.
            </p>

            <h2>6. Data subject requests</h2>
            <p>
                Processor will, to the extent legally permitted, notify Controller
                without undue delay of any data subject request received directly,
                and will assist Controller in responding to such requests.
            </p>

            <h2>7. Breach notification</h2>
            <p>
                Processor will notify Controller without undue delay, and in any
                event within 72 hours, of becoming aware of a personal data breach
                affecting Controller's data.
            </p>

            <h2>8. Return or deletion of data</h2>
            <p>
                On termination or expiry, Processor will, at Controller's election,
                return or securely delete all personal data within 30 days, save to
                the extent retention is required by law or by Controller's own GxP
                records retention policy.
            </p>

            <h2>9. Audit rights</h2>
            <p>
                Controller may audit Processor's compliance with this DPA once per
                year on reasonable notice, at Controller's cost, subject to
                confidentiality. Processor may satisfy audit obligations by making
                available its most recent SOC 2 or equivalent report.
            </p>

            <h2>10. Execution</h2>
            <p>
                {"{{TODO: signature blocks — Processor and Controller authorised representatives.}}"}
            </p>
        </LegalPage>
    );
}
